import { SET_DISPLAYED_ADDRESS_ID } from 'redux/modules/address/actions/types';

export default id => ({
  payload: { id },
  type: SET_DISPLAYED_ADDRESS_ID,
});
